import { API_AUTH_LOGOUT } from '@/shared/constants/bff-endpoints';


export async function logoutRequest (): Promise<void> {
    await fetch(API_AUTH_LOGOUT, { method: 'POST' });
}
